<template>
  <div>
    <v-text-field
      v-model="num"
      outlined
      :label="name"
      :readonly="readonly"
      :disabled="disabled"
      append-outer-icon="mdi-plus"
      prepend-icon="mdi-minus"
      @click:append-outer="plus"
      @click:prepend="minus"
    >
    </v-text-field>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Input',

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    num: null
  }),

  computed: {},

  watch: {
    num: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.num)) {
          return;
        }
        this.setData();
      }
    }
  },

  created() {},

  methods: {
    setData() {
      this.num = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', this.num);
    },
    plus() {
      let intnum = parseInt(this.num);

      if (intnum > 0) {
        intnum = intnum + 1;
        this.num = intnum.toString();
      } else {
        this.num = '1';
      }
    },
    minus() {
      let intnum = parseInt(this.num);
      if (intnum > 0) {
        intnum = intnum - 1;
        this.num = intnum.toString();
      } else {
        this.num = '0';
      }
    }
  }
};
</script>
